import { IconX } from "@tabler/icons-react";
import { Link } from "react-router";
import { useState } from "react";

const CategoryModal = (props: any) => {

    const [openCategoryId, setOpenCategoryId] = useState<number | null>(null);

    const toggleCategory = (id: number) => {
        setOpenCategoryId((prev) => (prev === id ? null : id));
    };

    const renderSubcategories = (category: any, level: number = 1) => {

        if (!category.children || category.children.length === 0) return null;

        return (
            <ul className="list-unstyled">
                {category.children.map((sub: any) => (

                    <li key={sub.id} style={{ paddingRight: level * 15 }} className="py-1 font-medium-lg px-0">

                        <Link
                            to="#"
                            onClick={() => props.handleNavigate(sub.slug)}
                            data-bs-dismiss="modal"
                            className={`text-decoration-none d-block ${level >= 2 ? "text-secondary small" : "text-dark fw-semibold"}`}
                        >
                            {sub.name}
                        </Link>
                        {renderSubcategories(sub, level + 1)}
                    </li>

                ))}
            </ul>
        );

    };

    return (
        <div className="modal fade" id="modal-menu">
            <div className="modal-dialog modal-dialog-scrollable modal-fullscreen">
                <div className="modal-content">

                    <div className="modal-header align-items-center justify-content-between">
                        <h6 className="card-title mb-0">انتخاب دسته بندی</h6>

                        <button
                            className="bg-white border-0 p-0"
                            data-bs-dismiss="modal"
                        >
                            <IconX className="font-medium" />
                        </button>
                    </div>

                    <div className="modal-body">

                        <div className="accordion" id="accordionExample">

                            {props.parentCategory?.map((category: any) => (

                                <div className="accordion-item" key={category.id}>

                                    <h2 className="accordion-header">

                                        <button
                                            className={`accordion-button shadow-none ${openCategoryId === category.id ? "" : "collapsed"}`}
                                            type="button"
                                            onClick={() => toggleCategory(category.id)}
                                        >
                                            {category.name}
                                        </button>

                                    </h2>

                                    <div
                                        className={`accordion-collapse collapse ${openCategoryId === category.id ? "show" : ""}`}
                                    >

                                        <div className="accordion-body py-2">

                                            {renderSubcategories(category)}

                                        </div>

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
};

export default CategoryModal;
